import bodybuilder from 'bodybuilder'
import { Topics } from 'components/icons/topics'
import { WordCloud } from 'components/word-cloud/component'
import { DateRanges, DateRangesAsDropdownOptions } from 'elasticsearch/constants'
import {
  AggregationType,
  CONCEPT_TAG_TYPES,
  FilterType,
  IndexName,
  TAG_TYPE_FIELD,
  toFilter,
} from 'elasticsearch/constants'
import { ResponseAggregate, ResponsePayload } from 'elasticsearch/types'
import { Dataset } from 'generic/dataset'
import {
  ElasticsearchComponent,
  ElasticsearchProps,
} from 'generic/elasticSearchComponent'
import * as GenericRedux from 'generic/genericRedux'
import React, { ComponentType } from 'react'
import { connect, ConnectedComponentClass } from 'react-redux'
import * as ReactStrap from 'reactstrap'
import * as Router from 'router'
import { RasaAnalyticsComponent } from '../../analytics/rasa-analytics-component'
import {TopTopic} from './types'
import {Fields} from "../../../shared/modals";

export class TopTopicsComponentClass extends RasaAnalyticsComponent<any, any> {
  constructor(props) {
    super(props)
    this.state = {
      selectedDateRange: DateRangesAsDropdownOptions[5],
    }
  }

  public render() {
    return (
      <div>
        <div className="widget-title"><a href="#" onClick={() => this.props.push('/analytics/topics')}>
          {this.props.title}</a>
        </div>
        <TopTopicsWidget dateRange={DateRanges.WeeklyAverage}/>
      </div>
    )
  }
}

export const TopTopicsComponent = connect(
  null,
  {
    push: Router.push,
  },
)(TopTopicsComponentClass)

type Topics = TopTopic[]

interface TopicsProps extends ElasticsearchProps<Topics> {
  dateRange: any,
  shuffle: true,
}

interface TopicsState {
  loaded: boolean,
  excludedTopics: string[],
}

const TAG_NAME_AGG: string = 'tag'
const WEIGHTED_AGG: string = 'weighted'

class TopTopicsWidgetComponent extends ElasticsearchComponent<Topics, TopicsProps, TopicsState> {
  constructor(p: TopicsProps) {
    super(p, IndexName.TAGS)
    this.state = {
      loaded: false,
      excludedTopics: [],
    }
  }

  public parseResponse(payload: ResponsePayload): Promise<Topics> {
    this.setState({
      loaded: true,
    })
    const aggregations = payload.aggregations[TAG_NAME_AGG]
    return Promise.resolve(aggregations.buckets.map((aggregation: ResponseAggregate) => {
      const weightedAgg = (aggregation as any)[WEIGHTED_AGG]
      const weighted = Math.round((weightedAgg && weightedAgg.value) || 0)
      return {
        name: aggregation.key,
        totalClicks: aggregation.doc_count,
        // Word-cloud sizing uses `count`; switch it to the weighted score.
        count: weighted || aggregation.doc_count,
        value: aggregation.key,
        key: aggregation.key,
      }
    }))
  }

  public componentDidMount() {
    // Override the parent componentDidMount to load excluded topics after communityId is set
    this.context.user.init().then(({person, activeCommunity}) => {
      this.communityId = activeCommunity.communityId
      this.loadExcludedTopics()
    })
  }

  public componentDidUpdate(oldProps: TopicsProps) {
    if ( this.props.dateRange !== oldProps.dateRange ) {
      this.search()
    }
  }

  private loadExcludedTopics = () => {
    new Dataset()
      .loadCommunityDataset('communityExcludedTopics', this.communityId, [])
      .then((response) => {
        const excludedTopics = (response[0] || []).map((topic: any) => topic.topic)
        this.setState({ excludedTopics }, () => {
          // Trigger search after loading excluded topics
          this.search()
        })
      })
      .catch((error) => {
        // Continue without excluded topics filter
        this.setState({ excludedTopics: [] })
      })
  }

  public searchPayload(): any {
    let search = bodybuilder().size(0)
    .filter(FilterType.range, 'message_send_date', toFilter(this.props.dateRange))
    // Insights only: keep concepts, drop categories (covers both case variants).
    .filter(FilterType.terms, TAG_TYPE_FIELD, CONCEPT_TAG_TYPES)

    // Filter out excluded topics
    if (this.state.excludedTopics && this.state.excludedTopics.length > 0) {
      this.state.excludedTopics.forEach(excludedTopic => {
        search = search.notFilter(FilterType.term, 'text.keyword', excludedTopic)
      })
    }

    return this.addAggregation(search, {
      type: AggregationType.terms,
      field: 'text.keyword',
      name: TAG_NAME_AGG,
      extra: {
        size: '30',
        order: { [WEIGHTED_AGG]: 'desc' },
      },
      childs: [
        { type: AggregationType.sum, field: 'weight', name: WEIGHTED_AGG },
      ],
    }).build()
  }

  public render = () => <div>
    <div className="topics-chart">
      {this.props.results && this.props.results.length > 0 ?
      <div>
        <div>
    <ReactStrap.Row>
    <ReactStrap.Col sm="12" md="12">
            <WordCloud data={this.props.results} shuffle={false} />
          </ReactStrap.Col>
    </ReactStrap.Row>
        </div>
      </div> :
      <div>
        <p className="no-data-tag-widget">
            No Topic Available
        </p>
    </div>
      }
    </div>
  </div>
}

export const TopTopicsWidget: ConnectedComponentClass<ComponentType<TopTopicsWidgetComponent>, Fields> = GenericRedux.registerNewComponent(
  TopTopicsWidgetComponent, 'home_topics', {})
